module.exports = __webpack_public_path__ + "img/circle_user_dark.0edca164.svg";